import * as Popper from "@popperjs/core";

$( function () {
  const popcorn = document.querySelector( '#member-sign' );
  const tooltip = document.querySelector( '.membership-popover' );
  // tooltip.classList.add('hide');

  if ( popcorn && tooltip ) {
    const popper = Popper.createPopper( popcorn, tooltip, {
      placement: 'bottom',
      modifiers: [ {
        name: 'offset',
        options: {
          offset: [ -50, 0 ],
        },
      }, ],
    } );

    popcorn.addEventListener( "mouseenter", function () {
      tooltip.classList.remove( "hide" )
      // We need to tell Popper to update the tooltip position
      // after we show the tooltip, otherwise it will be incorrect
      popper.update();
    } );


    popcorn.addEventListener( "mouseleave", function () {
      tooltip.classList.add( "hide" )
    } );
  }

} )



// WEBPACK FOOTER //
// ./scripts/plugins/popper.js